"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFullScreenConteudoDigital = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var icon_with_hyperlink_1 = require("../icon-with-hyperlink");
var iframe_full_1 = require("../iframe-full");
var modal_full_screen_conteudo_digital_styles_1 = require("./modal-full-screen-conteudo-digital.styles");
var modalRootContainer = document.querySelector('#modal-root');
var ModalFullScreenConteudoDigital = function (_a) {
    var headerTitle = _a.headerTitle, btnVoltarLabel = _a.btnVoltarLabel, btnVoltarOnClick = _a.btnVoltarOnClick, iFrameTitle = _a.iFrameTitle, iFrameUrl = _a.iFrameUrl, tagConteudoDigital = _a.tagConteudoDigital, _b = _a.focusEnabled, focusEnabled = _b === void 0 ? true : _b;
    var isMobile = (0, temas_frontend_1.useMobile)();
    var component = (0, react_1.useMemo)(function () { return (react_1.default.createElement(react_focus_lock_1.default, { disabled: !focusEnabled, autoFocus: true },
        react_1.default.createElement(modal_full_screen_conteudo_digital_styles_1.DialogContainerStyled, { "aria-modal": true, "data-testid": "modal-full-screen-conteudo-digital" },
            react_1.default.createElement(modal_full_screen_conteudo_digital_styles_1.DialogHeaderStyled, null,
                react_1.default.createElement("span", { role: "region", className: "somenteLeitorDeTela", tabIndex: 0 }, "Voc\u00EA est\u00E1 na modal do conte\u00FAdo do tema"),
                react_1.default.createElement(modal_full_screen_conteudo_digital_styles_1.DialogHeaderLeftSideContentStyled, null,
                    react_1.default.createElement(icon_with_hyperlink_1.IconWithHyperlink, { icon: react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.ArrowLeft, size: "md" }), label: isMobile ? '' : btnVoltarLabel, onClick: btnVoltarOnClick })),
                isMobile && (react_1.default.createElement(react_1.default.Fragment, null, tagConteudoDigital && tagConteudoDigital.props.children ? (headerTitle) : (react_1.default.createElement(modal_full_screen_conteudo_digital_styles_1.DialogTitleStyled, { "data-testid": "dialog-full-width" }, headerTitle)))),
                !isMobile && react_1.default.createElement(modal_full_screen_conteudo_digital_styles_1.DialogHeaderMainContentStyled, null, headerTitle),
                react_1.default.createElement(modal_full_screen_conteudo_digital_styles_1.DialogHeaderRightSideContentStyled, null, tagConteudoDigital)),
            react_1.default.createElement(modal_full_screen_conteudo_digital_styles_1.DialogContentStyled, null,
                react_1.default.createElement(iframe_full_1.IFrameFull, { titulo: iFrameTitle, url: iFrameUrl }))))); }, [btnVoltarLabel, btnVoltarOnClick, headerTitle, iFrameTitle, iFrameUrl, isMobile, tagConteudoDigital]);
    if (modalRootContainer) {
        return (0, react_dom_1.createPortal)(component, modalRootContainer);
    }
    return component;
};
exports.ModalFullScreenConteudoDigital = ModalFullScreenConteudoDigital;
